import { acpConnectedBanksStates } from './states';

export default function(appModule) {
  appModule.config(acpConnectedBanksStates);
}
